import { useTranslation } from 'react-i18next';

import { MirrorService } from 'services/MirrorService';
import { Package } from 'types/interfaces/Package';

import {
  applyCurrencySymbol,
  getCurrencySymbol,
  getDurationLabelKey,
  getPriceAfterDiscount,
  getPriceByDuration,
  roundToTwoDigits,
} from 'helpers/price';

interface PackPriceProps {
  package?: Package | null;
  isVip?: boolean;
}

export const usePackPrice = ({ package: pack, isVip }: PackPriceProps) => {
  const { t } = useTranslation('common');

  const isArjalozMidsVipPack = MirrorService.isArjalozMids && isVip;

  if (!pack) return null;

  const {
    currency,
    display_price: displayPrice,
    initial_price_full: initialPriceFull,
    recurring_price_full: recurringPriceFull,
    duration_init: durationInit,
    duration,
    discount,
  } = pack;
  const isHasDiscount = pack.discount > 0;
  const currencySymbol = getCurrencySymbol(currency);
  const durationLabel = isArjalozMidsVipPack
    ? t('banners_product.week')
    : t(getDurationLabelKey(displayPrice));

  const applyCurrency = (cost?: string) => {
    if (cost) {
      return applyCurrencySymbol(cost, currency);
    }

    return '';
  };

  const finalDurationInit = isArjalozMidsVipPack ? 1 : durationInit;
  const initialByPeriod = getPriceByDuration(
    initialPriceFull,
    finalDurationInit
  );
  const afterDiscount = isHasDiscount
    ? getPriceAfterDiscount(initialPriceFull, discount)
    : initialPriceFull;
  const afterDiscountByPeriod = getPriceByDuration(
    afterDiscount,
    finalDurationInit
  );

  return {
    isHasDiscount,
    discount,
    currency,
    currencySymbol,
    duration,
    durationLabel,
    recurringInitial: roundToTwoDigits(recurringPriceFull),
    initial: roundToTwoDigits(initialPriceFull),
    initialByPeriod: roundToTwoDigits(initialByPeriod),
    afterDiscount: roundToTwoDigits(afterDiscount),
    afterDiscountByPeriod: roundToTwoDigits(afterDiscountByPeriod),
    applyCurrency,
  };
};
